module.exports = __webpack_public_path__ + "static/media/laso-app-thumb.35ed62e3.PNG";